import type { BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { useFeatureGate } from '@statsig/expo-bindings';
import { Link } from 'expo-router';
import { View, YStack } from 'smoothie';

import LogoIcon from '../../../../assets/images/logos/fruitful-logo-icon-only.svg';
import Logo from '../../../../assets/images/logos/logo-new.svg';
import Screens from '../../../common/types/Screens';
import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import { SideNavBarItem } from './SideNavBarItem';

export const SIDE_NAV_WIDTH_SM = 80;
export const SIDE_NAV_WIDTH_MD = 205;
export const SIDE_NAV_WIDTH_LG = 250;
const NARROW_LOGO_SECTION_HEIGHT = 100;

interface SideNavBarProps extends BottomTabBarProps {}

export const SideNavBar = ({
    descriptors,
    state,
    navigation,
}: SideNavBarProps) => {
    const { value: enableImTab } = useFeatureGate(FeatureFlags.ENABLE_IM_TAB);

    return (
        <YStack
            backgroundColor="$white"
            borderColor="$gray100"
            borderRightWidth={2}
            alignItems="center"
            width={SIDE_NAV_WIDTH_SM}
            $md={{
                width: SIDE_NAV_WIDTH_MD,
                alignItems: 'flex-start',
                paddingHorizontal: 12,
            }}
            $lg={{
                width: SIDE_NAV_WIDTH_LG,
                alignItems: 'flex-start',
                paddingHorizontal: 24,
            }}
            height="100%"
            position="absolute"
        >
            <Link href="/home">
                <View
                    marginTop={34}
                    marginBottom={50}
                    paddingHorizontal={16}
                    display="none"
                    $md={{ display: 'flex' }}
                >
                    <Logo height={24} />
                </View>
            </Link>
            <Link href="/home">
                <View
                    height={NARROW_LOGO_SECTION_HEIGHT}
                    paddingTop={40}
                    paddingBottom={44}
                    $md={{ display: 'none' }}
                >
                    <LogoIcon height={24} />
                </View>
            </Link>
            <YStack gap={4} width="100%">
                {state.routes.map((route, index) => {
                    const label = parseRouteLabel(descriptors, route);

                    if (
                        !enableImTab &&
                        route.name === Screens.Tabs.Investment
                    ) {
                        return null;
                    }

                    return (
                        <Link
                            key={route.key}
                            href={{
                                // TODO expo-router address typing and reliable url/href generation
                                // @ts-expect-error can't figure out how to handle route types
                                pathname:
                                    route.name === Screens.Tabs.Home
                                        ? '/home'
                                        : `/home/${route.name}`,
                                // @ts-expect-error can't figure out how to handle route types
                                params: route.params,
                            }}
                        >
                            <SideNavBarItem
                                index={index}
                                state={state}
                                descriptors={descriptors}
                                navigation={navigation}
                                routeKey={route.key}
                                routeName={route.name}
                                label={label}
                                routeParams={
                                    (route.params as Record<string, unknown>) ??
                                    {}
                                }
                            />
                        </Link>
                    );
                })}
            </YStack>
        </YStack>
    );
};

export function parseRouteLabel(
    descriptors: SideNavBarProps['descriptors'],
    route: SideNavBarProps['state']['routes'][0],
): string {
    const descriptor = descriptors[route.key];
    const title = descriptor?.options?.title;

    if (title != null && typeof title === 'string') {
        return title;
    }

    return route.name;
}
